import {UIElement} from "./ui";
import '/modules/common/css/ui/tooltip.css'
import '/modules/common/css/ui/tooltip.mobile.css'
import {nnTrim} from "../util";

/**
 * A tooltip to make the behavior of the "title" attribute predictable across browsers and devices
 * A tooltip will be shown when there is a title attribute with text and on the following conditions:
 * . If mobile, on touch and hold the element for at least 500ms
 * . If desktop, on hover the element
 * @extends UIElement
 */
class Tooltip extends UIElement {

    /**
     * @param id {string} A unique id for this tooltip
     * @param element {jQuery} The DOM application container
     */
    constructor(id, element) {
        super(id, undefined)
        this.target = element;

        this.uiElement = $('<div role="tooltip" class="tumbo-tooltip"></div>').click(() => this.hide());
        this.target.append(this.uiElement);

        const ignored = ['HTMLCanvasElement'];
        const handleEvent = event => {
            const domElement = document.elementFromPoint(event.pageX, event.pageY);
            const element = $(domElement);
            if(!domElement || element.hasClass('tooltiped'))
                return;
            if (ignored.indexOf(domElement.__proto__.constructor.name) < 0 && !$(domElement).hasClass('ol-control')) {
                if (nnTrim(element.attr('title')) || nnTrim(element.attr('data-title'))) {
                    this.show(element, event.clientX, event.clientY);
                } else this.hide();
            } else this.hide();
        };
        if(!tumbo.isMobileDevice) {
            this.target.mousemove((e)=>setTimeout(()=>handleEvent(e),100));
        } else {
            const onLongPress = callback => {
                let timer;

                this.target.on('touchstart', event => {
                    timer = setTimeout(() => {
                        timer = null;
                        callback(event.originalEvent.touches[0]);
                    }, 500);
                });

                const cancel = () => {
                    clearTimeout(timer);
                };
                this.target.on('touchend', cancel);
                this.target.on('touchmove', cancel);
                $(this.target).on('click', () => this.hide());
            };

            onLongPress(e => {
                this.hide();
                handleEvent(e);
            });
        }
    }

    getClassName() {
        return "Tooltip";
    }

    getCode() {
        return "tooltip";
    }

    getUIElement() {
        return this.uiElement;
    }

    /**
     * Shows a tooltip for an element on a screen position
     * Handles the problem of having a tooltip too close to the application margins
     * @param element The tooltiped element
     * @param x The X coordinate in pixels (should come from the user triggered event - hover or touch and hold)
     * @param y The Y coordinate in pixels (should come from the user triggered event - hover or touch and hold)
     */
    show(element, x, y) {
        this.hide();
        this.tooltipedElement = element;
        const text = this.tooltipedElement.attr('title');
        this.tooltipedElement.attr('data-title', text).removeAttr('title');
        this.uiElement.html(text).show();

        const targetPosition = this.target.position();
        const height = this.uiElement.height();
        const width = this.uiElement.width();
        const pos = this.tooltipedElement.offset();
        const tooltipedElementWidth = this.tooltipedElement.width();
        const tooltipedElementHeight = this.tooltipedElement.height();
        const maxLeftValue = targetPosition.left+this.target.width()-(tooltipedElementWidth+30);
        const idealLeftValue = pos.left+tooltipedElementWidth+5;
        const minTopValue = targetPosition.top+5;
        const idealTopValue = pos.top-height-10;
        let left = Math.max(5, Math.min(maxLeftValue,idealLeftValue));
        let top = Math.max(minTopValue,idealTopValue);
        if(maxLeftValue < (idealLeftValue+30) || minTopValue > (idealTopValue-20)) {
            //if the tooltiped element too close to the top or too close to the right
            left = Math.max(5, pos.left-tooltipedElementWidth-width-5);
            top = Math.max(minTopValue,pos.top+tooltipedElementHeight+5);
        }

        this.uiElement.css('left', left+'px').css('top', top+'px').show();
        this.tooltipedElement.addClass('tooltiped');
        this.logStat("SHOW");
    }

    /**
     * Hides any visible tooltip
     */
    hide() {
        if (this.tooltipedElement) {
            const text = nnTrim(this.tooltipedElement.attr('title'), this.tooltipedElement.attr('data-title'));//title attr can change while tooltip is visible
            this.tooltipedElement.attr('title', text);
            this.uiElement.hide();
            $('.tooltiped',this.target).removeClass('tooltiped');
        }
    }
}

export {Tooltip}